import { Tooltip } from '@mui/material'
import React from 'react'
import { useState } from 'react'
import { currencyText } from '../../../../../helpers/unitMeasure/UnitMeasureHelper'
import MyModal from '../../../../UI/modal/MyModal'
import ChangePriceWriteOffActItemForm from './ChangePriceWriteOffActItemForm'

const ChangePriceWriteOffActItemButton = ({ writeOffActItem }) => {

    const [open, setOpen] = useState(false)

  return (
     <>
        {/* <div className='supplyCounts cursorP' */}
        <div className='supplyCounts'
            // onClick={e => setOpen(true)}
        >
            <p className='supplyCounts__green'>
                <Tooltip title='За одиницю'>
                    {writeOffActItem.priceOne ? writeOffActItem.priceOne : 0}
                </Tooltip>
            </p>
            <span>/</span>
            <p className='supplyCounts__yellow'>
                <Tooltip title='Загалом'>
                    {writeOffActItem.priceGeneral ? writeOffActItem.priceGeneral : 0}
                </Tooltip>
            </p>
            <p>
                {
                    // unitMeasureShortText[supplyOrderItem.unitMeasure]
                    currencyText['UAH']
                }
            </p>
        </div>

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Редагувати вартість позиції'}
            disableClickOutside={true}
            content={
                <ChangePriceWriteOffActItemForm
                    // supplyOrderId={supplyOrderId}
                    writeOffActItemBd={writeOffActItem}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default ChangePriceWriteOffActItemButton